import { CONSTANTS as COMMON_CONSTANTS } from '@common/constants/common.constants';

import { EUserRoles } from '@enums';
import { environment } from '@env/environment';

// tslint:disable-next-line:max-line-length
import { FullScreenMessageComponent } from '@web/shared/components/full-screen-message/full-screen-message.component';
// tslint:disable-next-line:max-line-length
import { AbsentChildDialogComponent } from '@web/modules/children/children-status-list/absent-child-dialog/absent-child-dialog.component';
// tslint:disable-next-line:max-line-length
import { DelayChildDialogComponent } from '@web/modules/children/children-status-list/delay-child-dialog/delay-child-dialog.component';
// tslint:disable-next-line:max-line-length
import { BitfMatOkCancelDialogComponent } from '@bitf/core/components/ui/ok-cancel-dialog/material';

const auth0ClientId = {
  development: '4x3PDOND01rHl55NIWJYyf6pWRf1X1R7',
  'remote-development': '4x3PDOND01rHl55NIWJYyf6pWRf1X1R7',
  staging: 'Qg0PoWqWtH7A8Ayyn19fBm625EAS7BjQ',
  production: 'Bbi40k1UpGJA9d7kIK9ika6PQB8amnid',
};

const auth0Domain = {
  development: 'cm-inter-dev.eu.auth0.com',
  'remote-development': 'cm-inter-dev.eu.auth0.com',
  staging: 'cm-inter-test.eu.auth0.com',
  production: 'cm-inter.eu.auth0.com',
};

export const WEB_CONSTANTS = {
  appName: 'Children monitor - parent app',
  fullScreenMessageComponent: FullScreenMessageComponent,
  absentChildDialogComponent: AbsentChildDialogComponent,
  delayChildDialogComponent: DelayChildDialogComponent,
  okCancelDialogComponent: BitfMatOkCancelDialogComponent,
  // NOTE: redirectUri and returnTo are set in the auth.service initAuth0 function based on device (/m)
  auth0Config: {
    clientID: auth0ClientId[environment.name] || auth0ClientId.development,
    domain: auth0Domain[environment.name] || auth0Domain.development,
    responseType: 'token id_token',
    scope: 'openid',
    audience: environment.audience,
    redirectUri: '',
    returnTo: '',
  },
  allowedUserTypes: [EUserRoles.PARENT],
  userRole: EUserRoles.PARENT,
  LOCAL_STORAGE_VERSION: 1,
};

export const CONSTANTS = Object.assign(COMMON_CONSTANTS, WEB_CONSTANTS);
